/**
 * @generated SignedSource<<ab5457fcbd980dbd495cc74a28a363e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SeparateSupplierSpellingInput = {
  spelling: string;
};
export type SeparateSupplierSpellingDialogMutation$variables = {
  input: SeparateSupplierSpellingInput;
};
export type SeparateSupplierSpellingDialogMutation$data = {
  readonly separateSupplierSpelling: {
    readonly id: string;
  };
};
export type SeparateSupplierSpellingDialogMutation = {
  response: SeparateSupplierSpellingDialogMutation$data;
  variables: SeparateSupplierSpellingDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "separateSupplierSpelling",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeparateSupplierSpellingDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeparateSupplierSpellingDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e6f09a10dbf5a95724af4424fce414ba",
    "id": null,
    "metadata": {},
    "name": "SeparateSupplierSpellingDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SeparateSupplierSpellingDialogMutation(\n  $input: SeparateSupplierSpellingInput!\n) {\n  separateSupplierSpelling(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd7bd7ff4b18fed29895f1ad68a6a5f2";

export default node;
